import { render } from "./educationalOfflinePage.vue?vue&type=template&id=58ff33b6&scoped=true"
import script from "./educationalOfflinePage.vue?vue&type=script&lang=js"
export * from "./educationalOfflinePage.vue?vue&type=script&lang=js"

import "./educationalOfflinePage.vue?vue&type=style&index=0&id=58ff33b6&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58ff33b6"]])

export default __exports__